<div class="container-fluid main-container">
  <div class="row justify-content-md-center title-container">
    <div class="col">
      <h1>FAQ</h1>
    </div>
  </div>
  <div class="row justify-content-md-center text-center">
    <div class="col mb-3 p-5">
      <h2>Page en construction</h2>
    </div>
  </div>
</div>
